import {Component, OnInit, Input, NO_ERRORS_SCHEMA, NgModule, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {User} from '../../../../model/user';
import {UserService} from '../../../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {appConfig} from '../../../../app.config';
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from '../../../../components/app-arc';
import {BranchesShowComponent} from "../../branches/branches-show/branches-show.component";
import {DepartmentsShowComponent} from "../../departments/departments-show/departments-show.component";
import {PermissionsShowComponent} from "../../permissions/permissions-show/permissions-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {BranchService} from '../../branches/branch.service';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule, MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        UsersShowComponent
    ],
    entryComponents: [
        UsersShowComponent
    ],
    exports: [],
    providers: [SharedService, UserService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-users-show',
    templateUrl: './users-show.component.html',
    styleUrls: ['./users-show.component.scss'],
    providers: [UserService, ConfirmationService, MessageService]
})

export class UsersShowComponent implements OnInit, AfterViewInit {
    id: string;
    user: User;
    applog: AppLogComponent;
    @Input() refShow;
    @Input() modelName;
    @Input() delId;
    @Input() oldData;
    @Input() newDatap;
    @Input() newData;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent: any;


    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
    firstVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
    auth = [{'val': 0, 'title': 'None'}, {'val': 1, 'title': 'Email'}, {'val': 2, 'title': 'Mobile'}];

    form: FormGroup;
    private sub: any;
    public msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    roles: any[] = [];

    allbranches: any[] = [];
    branches_enhance: any[] = [];
    departments_enhance: any[] = [];
    alldepartments: any[] = [];
    departmnets_enhance: any[] = [];
    branches: SelectItem[] = [];
    departments: SelectItem[] = [];
    newUser: any[] = [];
    newBranches: any[] = [];
    newDepartments: any[] = [];
    oldUser: any[] = [];
    oldBranches: any[] = [];
    oldDepartments: any[] = [];
    row_id: any;

    status: any;
    change_password_first_login: any;
    two_factor_authentication: any;
    image: any;
    oldImage: any;
    Selectedbranch: any;
    Selecteddepartment: any;
    branchCount: any[] = [];
    departmentCount: any[] = [];
    deletedrow: any[] = [];
    deleteddepartment: any[] = [];
    selectedrol: any[] = [];

    Selected_branches_db: string[] = [];
    Selected_departments_db: string[] = [];
    selectedBranches: string[] = [];
    selectedDepartments: string[] = [];

    permissions:string;
    mainbranch: any = {value:"", inx:-1};
    mainbranch_old: any = {value:"", inx:-1};
    maindepartment: any = {value:"", inx:-1};
    maindepartment_old: any = {value:"", inx:-1};


    maindepartments: any = [];
    maindepartments_old: any = [];
    browse_lang = "en";
    Departmentsonbranches: any = [];
    Departmentsonbranches_old: any = [];

    restoreInv: any;
    Selected_branches: any[] = [];
    Selected_branches_old: any[] = [];

    Selected_departments: any[] = [];
    Selected_departments_old: any[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;
    private _recordButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private userService: UserService,
                private branchService: BranchService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        this.msgs =[];

        this.sharedservice.setItemShow(UsersShowComponent);

        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('users');
        // this.modelName = this.sharedservice.getModelName();

    }
    showParent(id:any) {
        if(id) {
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(PermissionsShowComponent, options);
            this.modalRef.componentInstance.scrId = id;
            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showBranch(id:any) {
        if(id) {
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(BranchesShowComponent, options);
            this.modalRef.componentInstance.scrId = id;
            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showDepartment(id:any) {
        if(id) {
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(DepartmentsShowComponent, options);
            this.modalRef.componentInstance.scrId = id;
            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    ngAfterViewInit() {
        if(!this.scrId && !this.oldData) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');
            this._recordButton = document.getElementById('recordButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/users/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteUser(this.user);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/users']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/users/search']);
                });

            }
        }
    }

    ngOnInit() {
        this.msgs = [];
        this.userService.getRoles().subscribe(
            rol => {
                this.roles = rol;
            }
        );
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.permissions = params['role_id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),
            email: new FormControl({value: '', disabled: true}),
            mobile: new FormControl({value: '', disabled: true}),
            tel: new FormControl({value: '', disabled: true}),
            change_password_first_login: new FormControl({value: '', disabled: true}),
            two_factor_authentication: new FormControl({value: '', disabled: true}),
            role_id: new FormControl({value: '', disabled: true}),
            picture: new FormControl({value: '', disabled: true})
        });

        if(this.id){
            this.delId = false;
            this.newDatap = true;
            this.oldData = false;
            this.newData = false;
            this.activeModal.dismiss('');

          this.branchService.getAllDepartments().subscribe(
            allbranches => {
              this.alldepartments = allbranches.departmentslist;
              this.departments_enhance = allbranches.departmentstable;
              this.Departmentsonbranches = Array(this.allbranches.length).fill(this.alldepartments);
            });

            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));

            if (msg){
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }

            this.userService.getById(this.id).subscribe(
                user => {
                  console.log(user);
                    this.id = user.id;
                    this.user = user;
                    this.parent = user.role_id;
                    this.row_id = user.row_id;
                    this.form.patchValue({
                        id: user.id,
                        name: user.name,
                        status: user.status,
                        email: user.email,
                        mobile: user.mobile,
                        tel: user.tel,
                        change_password_first_login: user.change_password_first_login,
                        two_factor_authentication: user.two_factor_authentication,
                        role_id: user.role_id,
                        picture: user.picture,
                    });

                    this.image = user.picture;
                    this.status = user.status;
                    this.change_password_first_login = user.change_password_first_login;
                    this.two_factor_authentication = user.two_factor_authentication;

                  this.Selected_branches = user.allbranch2;
                  this.branches = user.allbranch2;

                  //this.Selected_departments = user.alldepartment2;
                  this.departments = user.alldepartment2;

                  for (var x = 0; x < this.Selected_branches.length; x++) {
                    console.log(this.Selected_branches[x]);
                    this.Selected_branches_db.push(this.Selected_branches[x].value);
                    this.selectedBranches.push(this.Selected_branches[x].value);
                    this.Selected_departments[x] = {value :this.Selected_branches[x].department_id , inx: x};
                    if(this.Selected_branches[x].main_dep == 1){
                      this.maindepartments[this.Selected_branches[x].value] = this.Selected_branches[x].department_id;
                    }
                    this.selectedDepartments[x] = this.Selected_branches[x].department_id;
                    this.Departmentsonbranches[x] = this.Selected_branches[x].departmentsb;
                  }

                  console.log(this.maindepartments);
                  console.log(this.Selected_departments);

                  for (let bran in  this.Selected_branches) {
                    if (this.Selected_branches[bran].value == user.branch_id) {
                      this.mainbranch = this.Selected_branches[bran];
                    }
                  }

                }, error => {
                    console.log(error);
                }
            );
        }
        if(this.scrId){
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.userService.getById(this.scrId).subscribe(
                user => {
                    this.id = user.id;
                    this.user = user;
                    this.row_id = user.row_id;
                    this.form.patchValue({
                        id: user.id,
                        name: user.name,
                        status: user.status,
                        email: user.email,
                        mobile: user.mobile,
                        tel: user.tel,
                        change_password_first_login: user.change_password_first_login,
                        two_factor_authentication: user.two_factor_authentication,
                        role_id: user.role_id,
                        picture: user.picture,
                    });

                    this.image = user.picture;
                    this.status = user.status;
                    this.change_password_first_login = user.change_password_first_login;
                    this.two_factor_authentication = user.two_factor_authentication;

                    this.Selected_branches = user.allbranch;
                    for (let bran in  this.Selected_branches) {
                        if (this.Selected_branches[bran].value == user.branch_id) {
                            this.mainbranch = this.Selected_branches[bran];
                        }
                    }

                  this.Selected_departments = user.alldepartment;
                  for (let bran2 in  this.Selected_departments) {
                    if (this.Selected_departments[bran2].value == user.department_id) {
                      this.maindepartment = this.Selected_departments[bran2];
                    }
                  }

                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.userService.getTrashedById(this.delId).subscribe(
                user => {
                    this.id = user.id;
                    this.user = user;
                    this.row_id = user.row_id;
                    this.form.patchValue({
                        id: user.id,
                        name: user.name,
                        status: user.status,
                        email: user.email,
                        mobile: user.mobile,
                        tel: user.tel,
                        change_password_first_login: user.change_password_first_login,
                        two_factor_authentication: user.two_factor_authentication,
                        role_id: user.role_id,
                        picture: user.picture,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.oldData && this.newData){
          console.log(this.oldData);
          console.log(this.newData);
            this.user = this.newData;
            this.Selected_branches = this.newData.allbranch2;
            this.Selected_branches_old = this.oldData.allbranch2;
            this.row_id = this.newData.user.row_id;

            this.image = this.newData.user.picture;
            this.status = this.newData.user.status;
            this.change_password_first_login = this.newData.user.change_password_first_login;
            this.two_factor_authentication = this.newData.user.two_factor_authentication;


            this.restoreInv = this.oldData.user;

            this.restoreInv.branch_users = JSON.stringify(this.oldData.allbranch2);
            this.restoreInv.department_users = JSON.stringify(this.oldData.alldepartment2);



            for (let bran in  this.Selected_branches_old) {
                if (this.Selected_branches_old[bran].value == this.oldData.user.branch_id) {
                    this.mainbranch_old = this.Selected_branches_old[bran];
                }
            }

          for (var x = 0; x < this.Selected_branches_old.length; x++) {

            this.Selected_departments_old[x] = {value :this.Selected_branches_old[x].department_id , inx: x};
            if(this.Selected_branches_old[x].main_dep == 1){
              this.maindepartments_old[this.Selected_branches_old[x].value] = this.Selected_branches_old[x].department_id;
            }
            this.Departmentsonbranches_old[x] = this.Selected_branches_old[x].departmentsb;

          }

            for(let bran in  this.Selected_branches){
                if (this.Selected_branches[bran].value == this.newData.user.branch_id) {
                    this.mainbranch = this.Selected_branches[bran];
                }
            }
          for (var x = 0; x < this.Selected_branches.length; x++) {
            console.log(this.Selected_branches[x]);
            this.Selected_branches_db.push(this.Selected_branches[x].value);
            this.selectedBranches.push(this.Selected_branches[x].value);
            this.Selected_departments[x] = {value :this.Selected_branches[x].department_id , inx: x};
            if(this.Selected_branches[x].main_dep == 1){
              this.maindepartments[this.Selected_branches[x].value] = this.Selected_branches[x].department_id;
            }
            this.selectedDepartments[x] = this.Selected_branches[x].department_id;
            this.Departmentsonbranches[x] = this.Selected_branches[x].departmentsb;

          }

          for (let bran in  this.Selected_departments_old) {
            if (this.Selected_departments_old[bran].value == this.oldData.user.department_id) {
              this.maindepartment_old = this.Selected_departments_old[bran];
            }
          }

          for(let bran in  this.Selected_departments){
            if (this.Selected_departments[bran].value == this.newData.user.department_id) {
              this.maindepartment = this.Selected_departments[bran];
            }
          }

            this.form.patchValue({
                id: this.newData.user.id,
                name: this.newData.user.name,
                status: this.newData.user.status,
                email: this.newData.user.email,
                mobile: this.newData.user.mobile,
                tel: this.newData.user.tel,
                change_password_first_login: this.newData.user.change_password_first_login,
                two_factor_authentication: this.newData.user.two_factor_authentication,
                role_id: this.newData.user.role_id,
                picture: this.newData.user.picture,
                image: this.newData.picture,
            });
        }
    }

    deleteUser(user: User) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (user) {
                    this.userService.delete(user.id).subscribe(
                        res => {
                            this.msgs = [];
                            if(res.result){
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant('Delete completed')
                                });
                                setTimeout(() => {
                                    this.router.navigate(['/users']);
                                },1000);
                            }
                            else{
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(res.message)
                                });
                            }
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );  
                }
            }
        });
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.users.' + role) >= 0) {
            return true;
        }
        return false;
    }

    recoverEdit(user: User) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (user) {
                    this.userService.update(user).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/users/show', user.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.userService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/users/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        if (row_id) {
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
          const modalRef = this.modalService.open(AppLogComponent);
          modalRef.componentInstance.rowId = row_id;
          modalRef.componentInstance.refShow = UsersShowComponent;
        }
    }
    recordData() {
      console.log(this.user);
        // const options: NgbModalOptions = {
        //
        //     beforeDismiss: () => {
        //         // this.changePicUrl();
        //         return true;
        //     }
        // };
        // const modalRef = this.modalService.open(RecordDataComponent, options);
        // modalRef.componentInstance.refRec = this.user;
        // modalRef.componentInstance.rowId ="";
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/users/users-show/users-show.component.ts